(function ($) {
    'use strict';
    $(document).ready(function () {

        var resources = [
            "sylius_taxon",
            "sylius_product_attribute",
            "sylius_product_option",
            "sylius_customer_group",
            "sylius_promotion",
            "sylius_zone",
            "sylius_payment_method",
            "sylius_shipping_method",
            "sylius_tax_rate",
            "csl_stock_order",
            "csl_gift_cart",
            "csl_points"
        ];

        for (var i in resources) {
            var resource = resources[i];
            var element = $("#" + resource + "_code");

            if (!element.length) continue;

            var field = $(element)
                .closest(".field");

            field.hide();

            field.closest(".two.fields")
                .removeClass("two")
                .removeClass("fields")
                .addClass("field")
            ;

            field.closest(".three.fields")
                .removeClass("three")
                .addClass("two")
            ;
        }
    });
})(jQuery);
